import React, { memo, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import useStyle from './styles';
import { RfqReview } from '@modules/review';
import { useSelector } from '@store';

interface TextFieldBoxProps {
  placeholder?: string;
}

const TextFieldBox: React.FC<TextFieldBoxProps> = ({
  placeholder
}: TextFieldBoxProps) => {
  const textCounter = useRef<HTMLSpanElement>(null);
  const classes = useStyle();
  const { control, errors } = useFormContext<RfqReview>();
  const review = useSelector((state) => state.review);
  const { transactionSatisfactionComment: comment, reviewId } = review;
  const hasReview = reviewId !== '';
  const validate = (text: string) => {
    const result = text.replace(/\n|\r|\s*/g, '').length;
    return result < 10 ? false : true;
  };

  return (
    <>
      <CustomizedTypography
        variant="body2"
        color="textSecondary"
        className={classes.numberOfLetters}
      >
        <span ref={textCounter}></span>
      </CustomizedTypography>
      <Controller
        name="transactionSatisfactionComment"
        defaultValue={comment}
        control={control}
        rules={{ required: true, validate }}
        render={({ onChange }) => (
          <TextField
            multiline
            maxRows={9}
            minRows={9}
            placeholder={placeholder}
            defaultValue={hasReview ? comment : null}
            variant="outlined"
            className={classes.textField}
            onChange={(e) => {
              const text = e.currentTarget.value ?? '';
              const textLength = text.trim().replace(/\n|\r|\s*/g, '').length;

              if (!textCounter.current) return;

              textCounter.current.innerText = `${textLength.toLocaleString()}/5,000`;
            }}
            onBlur={onChange}
            error={!!errors['transactionSatisfactionComment']}
            inputProps={{
              maxLength: 5000
            }}
          />
        )}
      />
      {errors['transactionSatisfactionComment'] && (
        <CustomizedTypography variant="caption" color="error">
          최소 10자 이상 작성해주세요.
        </CustomizedTypography>
      )}
    </>
  );
};

export default memo(TextFieldBox);
